export const QUOTATION_UPDATE_DELIVERY = '/proposal/quotation/update/delivery'
